import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import {
  ButtonElementTypes,
  ButtonSizeMD,
  ButtonSkinSecondary,
  ButtonVariants,
} from '@picsart/button';
import Button from '@picsart/button/Button';
import Link from 'next/link';

import useStore from '../../../services/store';
import TextLabel from '../TextLabel/TextLabel';
import tooltipStyles from '../tooltipStyles';

import useStyles from './styles';
import { IGenericChipsProps } from './types';

function GenericChips({
  name,
  formProps: props,
  chipValues,
  defaultChipValue,
  textLabel,
  labelPaddingTop,
  labelPaddingTopMobile,
  information,
  tooltipProps,
}: IGenericChipsProps) {
  const tooltipClasses = tooltipStyles({ tooltipProps });
  const classes = useStyles({ labelPaddingTop, labelPaddingTopMobile });
  const { setFieldValue } = useFormikContext();
  const setFormValue = useStore((state) => state.setFormValue);
  const currentValue = props.values[name];

  useEffect(() => {
    setFieldValue(name, defaultChipValue.value);
  }, []);

  return (
    <>
      <TextLabel
        className={classes.textLabel}
        tooltipClassName={tooltipClasses.tooltip}
        arrowClassName={tooltipClasses.tooltipArrow}
        required={false}
        htmlFor={name}
        label={textLabel}
        infoText={information}
      />

      <div className={classes.chips}>
        {chipValues.map((item: { title: string; value: string }) => {
          const { value } = item;
          const variant = currentValue === value ? ButtonVariants.Filled : ButtonVariants.Outline;

          return (
            <Link key={value} href={value} passHref>
              <Button
                onClick={() => {
                  setFormValue({ name, value });
                }}
                className={classes.chip}
                size={ButtonSizeMD}
                variant={variant}
                skin={ButtonSkinSecondary}
                tag={ButtonElementTypes.Link}
              >
                {item.title}
              </Button>
            </Link>
          );
        })}
      </div>
    </>
  );
}
export default GenericChips;
